import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Paragraph } from '@zillow/constellation-10';

import { ExpandableDisclaimer } from '@zillow/zrs-comet';

import { useGetDisclaimers } from '../../../../hooks/queries/rentalProtection';

const propTypes = {
  disclaimerTypes: PropTypes.string,
  displaySurplusTaxesAndFees: PropTypes.bool,
};

const defaultProps = {
  disclaimerTypes: 'full',
  displaySurplusTaxesAndFees: false,
};

const ExpandableDisclaimerWithData = ({ disclaimerTypes, displaySurplusTaxesAndFees }) => {
  const { mutateAsync: getDisclaimers } = useGetDisclaimers();
  const [data, setData] = useState(null);
  const {
    properties: {
      currentProperty: { listingAlias },
    },
  } = useSelector((state) => state);

  useEffect(() => {
    getDisclaimers({ listingAlias, disclaimerTypes }).then((response) => {
      setData(response);
    });
  }, []);

  return (
    <div data-testid="ExpandableDisclaimerWithData">
      {displaySurplusTaxesAndFees && (
        <Paragraph textStyle="body-xs" color="text.subtle" css={{ marginBottom: '200' }}>
          *plus applicable surplus lines taxes and fees
        </Paragraph>
      )}

      <ExpandableDisclaimer title="Legal disclaimer" disclaimerContent={data?.disclaimers} />
    </div>
  );
};

ExpandableDisclaimerWithData.propTypes = propTypes;
ExpandableDisclaimerWithData.defaultProps = defaultProps;

export default ExpandableDisclaimerWithData;
